define('controller/step/ProviderStep',['require','lib/controller/booking/BaseStep','collection/ProviderCollection','view/controller/booking/provider/ProviderStepView','view/controller/booking/provider/ProviderStepLayout'],function (require) {

	var BaseStep = require('lib/controller/booking/BaseStep');
	var ProviderCollection = require('collection/ProviderCollection');
	var ProviderStepView = require('view/controller/booking/provider/ProviderStepView');
	var ProviderStepLayout = require('view/controller/booking/provider/ProviderStepLayout');
	
	return BaseStep.extend({
		
		_step: 'provider',
		_providerCollection: null,
		
		/**
		 * Inits instance, collection, subscribe to events
		 */
		initialize: function() {
	        BaseStep.prototype.initialize.call(this);

	        this._providerCollection = new ProviderCollection();
	        this._providerCollection.fetch();
	        this._providerCollection.setComparator(_.bind(this.providerComparator, this));

	        this.listenTo(this._bookingModel, 'change:provider_id', this.updateInfo);
	        this.listenTo(this._providerCollection, 'sync', this.onDataFetch);
	        
	        // perform filter performers after all data fetched from server (like services, locations, etc.)
	        this.listenTo(this._stepManager, 'step:fetch', this.performCollectionFilters);
			// add filter to provider collection need for classes timeline or when we show services after providers
            this.listenTo(this._stepManager, 'step:init:service', this.addServiceFilter);

			if (Config.getInstance().getPluginStatus('location')) {
				this.listenTo(this._stepManager, 'step:init:location', this.addLocationFilter);
			}
			if (Config.getInstance().getPluginStatus('event_category')) {
				this.listenTo(this._stepManager, 'step:init:category', this.addCategoryFilter);
			}
	    },

        /**
		 * Triggers init event
         */
		triggerInit: function () {
            this.triggerStepEvent('init', [this, this._providerCollection]);
		},

	    /**
	     * Returns step view
	     * 
	     * @return ProviderStepLayout
	     */
		getView: function () {
			return new ProviderStepLayout({
	    		collection: this._providerCollection
	    	});
		},
		
		/**
		 * Calls when collection fetched from server
		 */
		onDataFetch: function () {
			this.triggerStepEvent('fetch');
			this.updateInfo();

			if (this._providerCollection.getDataCollection().length < 1) {
                this._stepManager.showStep('provider');
			} else if (this._providerCollection.getDataCollection().length == 1) {
				this._stepManager.hideStep('provider');
			}
            
            this._checkProviderExists();

            this.done();
		},
		
		/**
		 * Updates booking info data
		 */
		updateInfo: function () {
	   		this._bookingModel.set('provider', this._providerCollection.getDataCollection().getModelObj(
	    		this._bookingModel.get('provider_id')
	    	));
	    },

	    /**
	     * Calls before show view
	     */
	    beforeViewShow: function () {
	    	this.performCollectionFilters();
	    },

	    /**
	     * Apply filters to collection before show step view
	     */
	    performCollectionFilters: function () {
	    	this._providerCollection.performFilters();
	    },

	    /**
	     * Returns true if provider is selected
	     * 
	     * @return Boolean
	     */
	    isValid: function () {
            this.performCollectionFilters();
            this._autoSelectItem();
            
            this._checkProviderExists();

	    	if (this._bookingModel.get('provider_id')) {
	    		return true;
	    	}
	    	return false;
	    },
        
        _checkProviderExists: function () {
            var providerId = this._bookingModel.get('provider_id');
            var provider = this._providerCollection.getDataCollection().getModelObj(providerId);
            if (providerId && providerId != 'any') {
                if (
                    (this._providerCollection.getDataCollection().length && !provider)
                    || (this._providerCollection._once_synced && !this._providerCollection.getDataCollection().length)
                ) {
                    /*setTimeout(function () {
                        Backbone.history.navigate('error/e404', {
                            trigger: true,
                            replace: true
                        });
                    });*/
                }
            } 
        },

        /**
         * Auto select service if collection contains single service
         *
         * @private
         */
        _autoSelectItem: function () {
        	this.setIsSkipped(false);
            
            var providerToSelect = undefined;
            
			if (this._providerCollection.length === 1) {
				this.setIsSkipped(true);
			} else {
                var providersWithoutAny = this._providerCollection.filter(function (provider) { return provider.id != 'any' });
                if (providersWithoutAny.length == 1) {
                    this.setIsSkipped(true);
                    providerToSelect = providersWithoutAny[0];
                } 
            }
            

            if (this._bookingModel.get('provider_id')) {
                return;
            }

            if (this.isStepSkipped()) {
                var provider =  providerToSelect || this._providerCollection.first();
                if (provider.get('id') && provider.get('id') !== 'any') {
                    this._bookingModel.set('provider_id', provider.get('id'));
                }
            }
        },

		providerComparator: function (model1, model2) {
			if (model1.get('id') === 'any') {
				return -1;
			}
			if (model2.get('id') === 'any') {
				return 1;
			}
			return model1.get('position') - model2.get('position');
		},

        /**
         * Adds filter to service collection
         */
        addServiceFilter: function (step, collection) {
            collection.addFilter(_.bind(this.serviceFilter, this));
        },

		/**
         * Adds filter to location collection
         */
		addLocationFilter: function (step, collection) {
            collection.addFilter(_.bind(this.locationFilter, this));
        },
		/**
         * Adds filter to category collection
         */
		addCategoryFilter: function (step, collection) {
            collection.addFilter(_.bind(this.categoryFilter, this));
        },
        
        removeCollectionFilters: function () {
            collection.resetFilters();
        },

        /**
         * Filters service model
		 *
         * (Filter service collection by provider,
         * selected in this._bookingModel, taking in account 'any_unit' plugin
         *
         * @param Backbone.Model
         * @return Boolean
         */
        // @todo: fix classes for any_unit plugin here
		serviceFilter: function (model) {
        	if (!this._bookingModel.get('provider_id')) {
        		return true;
			}
			if (this._bookingModel.get('provider_id') === 'any') {
				return true;
			}
            if (this._providerCollection.length == 0) {
                // if provider collection is not loaded yet, we cannot check if provider exists in that collection
                return true;
            }
			var provider = this._providerCollection.get(this._bookingModel.get('provider_id'));
			if(!provider){
			    return true;
            }
        	if (!provider.get('event_map')) { // provider not attached
                // all services allowed, except classes ('class_id' param can be in model only if classes plugin is enabled)
                // return !model.get('class_id');
                if (model.get('class_id')) return false;
			}
			var unitMap = model.get('unit_map');
            
            if (provider.get('class_id')) {
                return unitMap && unitMap.hasOwnProperty(this._bookingModel.get('provider_id'));
            } else {
                return !unitMap || unitMap.hasOwnProperty(this._bookingModel.get('provider_id'));
            }
		},

		locationFilter: function (model) {
			if (!this._bookingModel.get('provider_id')) {
				return true;
			}
			if (this._bookingModel.get('provider_id') === 'any') {
				return true;
			}

			if(!model.get('units')){
				return false;
			}

			var units = model.get('units') || [];
			units = _.map(units, function (val) { return parseInt(val)});

			return units.indexOf(parseInt(this._bookingModel.get('provider_id'))) >= 0;
		},

		categoryFilter: function (model) {
			return this.locationFilter(model); //code the same
		}
	    
	});
	
});
